import { render } from "./TheB2bLogin.vue?vue&type=template&id=4bf0d723&scoped=true&lang=pug"
import script from "./TheB2bLogin.vue?vue&type=script&lang=js"
export * from "./TheB2bLogin.vue?vue&type=script&lang=js"

import "./TheB2bLogin.vue?vue&type=style&index=0&id=4bf0d723&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bf0d723"]])

export default __exports__